/* MachinePro, thème « Atelier lumineux ». Interactions utiles, sans dépendance. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Montants à la française ---------- */
  const euro = (cents, suffix) => {
    const c = Math.round(Number(cents) || 0);
    const int = Math.floor(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
    const dec = String(c % 100).padStart(2, '0');
    return `${int},${dec} €${suffix ? ` ${suffix}` : ''}`;
  };
  window.mpEuro = euro;

  /* ---------- Notification ---------- */
  const toast = $('[data-toast]');
  let toastTimer;
  // Notification en bas d'écran (ajout au panier, erreurs) : titre + texte + bouton, disparaît seule après 4,5 s
  const notify = (text, href, linkLabel, opts = {}) => {
    if (!toast) return;
    const erreur = !!opts.erreur;
    $('[data-toast-titre]', toast).textContent = opts.titre || (erreur ? 'Impossible d\'ajouter' : 'Ajouté au panier');
    $('[data-toast-text]', toast).textContent = text;
    const link = $('[data-toast-link]', toast);
    link.href = href;
    link.textContent = linkLabel;
    toast.classList.toggle('is-error', erreur);
    toast.classList.remove('is-on');
    toast.getBoundingClientRect();
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-on'), 4500);
  };
  toast?.querySelector('[data-toast-close]')?.addEventListener('click', () => { clearTimeout(toastTimer); toast.classList.remove('is-on'); });

  /* ---------- Méga-menus (ordinateur) ---------- */
  const megaBtns = $$('[data-mega]');
  const setMega = (btn, open) => {
    megaBtns.forEach((b) => {
      const on = b === btn && open;
      b.setAttribute('aria-expanded', String(on));
      document.getElementById(b.getAttribute('aria-controls')).hidden = !on;
    });
  };
  // Un seul minuteur pour tout le menu : passer de « Métal » à « Soudage » bascule directement,
  // la fermeture prévue pour l'ancien onglet est annulée par l'entrée dans le nouveau.
  const canHover = window.matchMedia('(hover: hover)').matches;
  const isOpen = (b) => b.getAttribute('aria-expanded') === 'true';
  let megaTimer;
  megaBtns.forEach((btn) => {
    const item = btn.closest('.nav__item');
    btn.addEventListener('click', () => {
      // Souris sur l'onglet : le menu est déjà ouvert par le survol, un clic ne doit pas le refermer.
      if (isOpen(btn) && canHover && item.matches(':hover')) return;
      setMega(btn, !isOpen(btn));
    });
    if (canHover) {
      item.addEventListener('mouseenter', () => {
        clearTimeout(megaTimer);
        if (isOpen(btn)) return;
        const open = () => setMega(btn, true);
        if (megaBtns.some(isOpen)) open();
        else megaTimer = setTimeout(open, 90);
      });
      item.addEventListener('mouseleave', () => {
        clearTimeout(megaTimer);
        megaTimer = setTimeout(() => { if (isOpen(btn)) setMega(btn, false); }, 220);
      });
    }
    item.addEventListener('focusout', (e) => { if (!item.contains(e.relatedTarget) && isOpen(btn)) setMega(btn, false); });
  });
  // Survoler un lien simple du menu (Promotions, Marques, SAV) ferme le panneau ouvert.
  if (canHover) {
    $$('.nav__link:not(.nav__link--parent)').forEach((link) => link.addEventListener('mouseenter', () => {
      clearTimeout(megaTimer);
      const open = megaBtns.find(isOpen);
      if (open) setMega(open, false);
    }));
  }


  /* ---------- En-tête mobile : ligne de recherche seule en haut après défilement ---------- */
  const hdrGroup = $('.shopify-section-group-header-group');
  const mobile = window.matchMedia('(max-width: 1099px)');
  if (hdrGroup) {
    let tick = false;
    // Texte d'aide adapté à la largeur du champ : complet sur ordinateur, raccourci sur mobile, minimal en ligne compacte.
    const field = $('#recherche');
    const longHint = field ? field.placeholder : '';
    const ctx2d = document.createElement('canvas').getContext('2d');
    const fits = (txt) => {
      const cs = getComputedStyle(field);
      ctx2d.font = `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
      // largeur du champ en haut de page (ligne entière), pas pendant l'animation de la ligne compacte
      const full = field.closest('.hdr__row2').clientWidth;
      return ctx2d.measureText(txt).width + 6 <= full - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
    };
    const check = () => {
      tick = false;
      const stuck = mobile.matches && hdrGroup.getBoundingClientRect().top < -40;
      hdrGroup.classList.toggle('is-stuck', stuck);
      if (field) field.placeholder = !mobile.matches ? longHint : stuck ? 'Rechercher…' : fits('Rechercher une machine, une marque…') ? 'Rechercher une machine, une marque…' : 'Rechercher une machine…';
    };
    window.addEventListener('scroll', () => { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
    mobile.addEventListener('change', check);
    window.addEventListener('resize', () => { if (!tick) { tick = true; requestAnimationFrame(check); } });
    check();
    // Barlow chargée après le premier calcul : on remesure avec la vraie police.
    if (document.fonts) document.fonts.ready.then(check);
  }

  /* ---------- Recherche instantanée : mots-clés, catégories puis produits pendant la frappe ---------- */
  const psForm = $('form.search[data-ps-url]');
  if (psForm && 'fetch' in window) {
    const input = $('input[name="q"]', psForm);
    const panel = $('[data-ps-panel]', psForm);
    const cache = new Map();
    let timer, ctrl, active = -1, lastQ = '';
    const options = () => $$('[role="option"]', panel);
    const place = () => {
      if (!window.matchMedia('(max-width: 1099px)').matches) return;
      const row = psForm.closest('.hdr__row2');
      const bottom = document.documentElement.classList.contains('is-searching') && row ? row.getBoundingClientRect().bottom : psForm.getBoundingClientRect().bottom + 6;
      document.documentElement.style.setProperty('--ps-top', `${Math.round(bottom)}px`);
    };
    const clearBtn = $('[data-ps-clear]', psForm);
    const backBtn = $('[data-ps-back]');
    const isMobile = () => window.matchMedia('(max-width: 1099px)').matches;
    const searching = () => document.documentElement.classList.contains('is-searching');
    // Croix de fermeture en haut à droite du panneau (ordinateur ; le mode plein écran du téléphone a son bouton retour)
    const croix = () => {
      if ($('.ps-x', panel)) return;
      panel.insertAdjacentHTML('afterbegin', '<button class="ps-x" type="button" aria-label="Fermer la recherche"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>');
    };
    const open = () => { croix(); place(); panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    const close = () => {
      input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1;
      if (searching()) { showStart(true); return; }
      panel.hidden = true;
    };
    // Ordinateur : champ vide et actif → même écran de départ que sur téléphone, dans le panneau
    const startDesktop = (quiet = false) => {
      if (isMobile() || input.value.trim().length >= 2 || document.activeElement !== input) return;
      // Déjà affiché (focus puis clic) : on ne reconstruit pas, la cascade en cours continue
      if (!panel.hidden && panel.classList.contains('is-start')) return;
      const q = quiet || !panel.hidden;
      showStart(q); panel.classList.toggle('is-quiet', q); panel.classList.add('is-start'); open();
    };
    const syncClear = () => { if (clearBtn) clearBtn.hidden = !input.value; };
    // Écran de départ du mode recherche (rien de tapé) : gabarit rendu par Shopify dans header.liquid
    const startTpl = $('[data-ps-start]', psForm);
    const showStart = (quiet = false) => {
      if (!startTpl) { panel.hidden = true; return; }
      const firstShow = panel.hidden && !quiet;
      panel.replaceChildren(startTpl.content.cloneNode(true));
      croix();
      $$('[role="option"]', panel).forEach((o, k) => { o.id = `ps-opt-${k + 1}`; });
      // Apparition en cascade seulement à l'ouverture (panneau encore fermé) ; retour depuis des résultats : affichage direct
      const pss = $('.pss', panel);
      if (pss && !reduced.matches && firstShow) {
        let k = 0;
        [...pss.children].forEach((el) => {
          const items = el.matches('.pss__chips, .pss__fams, .pss__more') ? [...el.children] : [el];
          items.forEach((it) => { it.style.setProperty('--i', k++); it.classList.add('pss-in'); });
        });
      }
      $$('img', panel).forEach((img) => {
        if (img.complete && img.naturalWidth) return;
        img.classList.add('is-wait');
        img.addEventListener('load', () => img.classList.remove('is-wait'), { once: true });
      });
      panel.hidden = false;
    };
    // Entrée animée : la ligne de recherche glisse de sa place jusqu'en haut (technique FLIP), la flèche retour s'ouvre, le panneau monte en fondu.
    const row = psForm.closest('.hdr__row2');
    let exitTimer;
    const enterSearch = () => {
      if (!isMobile() || searching()) return;
      clearTimeout(exitTimer);
      // On suit le champ lui-même (et non la ligne, dont la marge change) pour un départ sans décalage
      const before = psForm.getBoundingClientRect().top;
      document.documentElement.classList.add('is-searching');
      input.dataset.hint = input.placeholder;
      input.placeholder = 'Machine, marque, référence…';
      if (input.value.trim().length < 2) showStart();
      place();
      if (row && !reduced.matches) {
        const delta = before - psForm.getBoundingClientRect().top;
        row.animate([{ transform: `translateY(${delta}px)` }, { transform: 'none' }], { duration: 280, easing: 'cubic-bezier(.2,.7,.2,1)' });
        row.animate([{ boxShadow: '0 1px 0 rgba(225,228,230,0)' }, { boxShadow: '0 1px 0 rgba(225,228,230,1)' }], { duration: 280 });
        // Le fond blanc arrive en fondu (le contenu suit en cascade)
        panel.animate([{ backgroundColor: 'rgba(255,255,255,0)' }, { backgroundColor: 'rgba(255,255,255,1)' }], { duration: 220, easing: 'ease-out' });
      }
    };
    const exitSearch = () => {
      input.setAttribute('aria-expanded', 'false'); input.blur();
      const done = () => { document.documentElement.classList.remove('is-searching'); panel.hidden = true; if (input.dataset.hint) input.placeholder = input.dataset.hint; requestAnimationFrame(place); };
      if (reduced.matches) { done(); return; }
      panel.animate([{ opacity: 1 }, { opacity: 0, transform: 'translateY(12px)' }], { duration: 160, easing: 'ease-in', fill: 'forwards' });
      exitTimer = setTimeout(() => { panel.getAnimations().forEach((a) => a.cancel()); done(); }, 160);
    };
    const setActive = (i) => {
      const opts = options();
      if (!opts.length) return;
      active = (i + opts.length) % opts.length;
      opts.forEach((o, k) => o.classList.toggle('is-active', k === active));
      input.setAttribute('aria-activedescendant', opts[active].id);
      opts[active].scrollIntoView({ block: 'nearest' });
    };
    // Mots-clés locaux, ajoutés avant ceux de Shopify (qui n'en propose souvent qu'un)
    const norm = (t) => t.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
    const esc = (t) => t.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    let words = [];
    try { words = JSON.parse($('[data-ps-words]', psForm)?.textContent || '[]').filter((w) => w.t); } catch (e) { words = []; }
    // Singulier et pluriel comptent pour un seul mot-clé (« Compresseur à vis » / « Compresseurs à vis »)
    const key = (t) => norm(t).split(/\s+/).map((x) => x.replace(/s$/, '')).join(' ');
    const seen = new Set();
    words = words.filter((w) => { const k = key(w.t); if (seen.has(k)) return false; seen.add(k); return true; });
    const brands = words.filter((w) => w.m);
    // Marque tapée dans la recherche (« metalpro », « metal pro », « cormak »…)
    const brandIn = (q) => {
      const flat = norm(q).replace(/\s+/g, '');
      return brands.find((b) => { const n = norm(b.t).replace(/\s+/g, ''); return n.length >= 3 && flat.includes(n); });
    };
    const localWords = (q) => {
      const brand = brandIn(q);
      if (brand) {
        // Type de machine + marque : « grugeuse metalpro » → « Grugeuse de tubes MetalPro »
        const bn = norm(brand.t).replace(/\s+/g, '');
        const rest = norm(q).split(/\s+/).filter((tk) => tk && !bn.includes(tk) && !tk.includes(bn));
        if (rest.length) {
          const combos = words.filter((w) => !w.m).filter((w) => { const ws = norm(w.t).split(/[\s'’/&-]+/); return rest.every((tk) => ws.some((x) => x.startsWith(tk))); })
            .sort((a, b) => a.t.length - b.t.length).slice(0, 4).map((w) => ({ t: `${w.t} ${brand.t}`, combo: true }));
          return [...combos, { t: brand.t, m: 1 }].slice(0, 5);
        }
      }
      const toks = norm(q).split(/\s+/).filter(Boolean);
      return words.map((w) => {
        const n = norm(w.t), ws = n.split(/[\s'’/&-]+/);
        if (!toks.every((tk) => ws.some((x) => x.startsWith(tk)))) return null;
        return { ...w, score: n.startsWith(toks[0]) ? 0 : 1 };
      }).filter(Boolean).sort((a, b) => a.score - b.score || a.t.length - b.t.length).slice(0, 5);
    };
    const searchUrl = (t) => `${psForm.getAttribute('action')}?q=${encodeURIComponent(t)}&options%5Bprefix%5D=last`;
    const render = (html, q) => {
      panel.classList.remove('is-start');
      panel.innerHTML = html;
      croix();
      const found = localWords(q);
      if (found.length) {
        let list = $('#ps-lbl-mots', panel)?.nextElementSibling;
        if (!list) {
          let side = $('.ps__side', panel);
          if (!side) {
            const cols = $('.ps__cols', panel) || panel;
            side = document.createElement('div'); side.className = 'ps__side';
            if (cols === panel) { panel.prepend(side); $('.ps__empty', panel)?.remove(); } else cols.prepend(side);
          }
          side.insertAdjacentHTML('afterbegin', '<p class="ps__lbl" id="ps-lbl-mots">Suggestions</p><ul class="ps__list" role="group" aria-labelledby="ps-lbl-mots"></ul>');
          list = $('#ps-lbl-mots', panel).nextElementSibling;
        }
        const have = new Set($$('.ps__kw', list).map((a) => key(a.textContent.trim())));
        const qn = norm(q);
        const items = found.filter((w) => !have.has(key(w.t))).map((w) => {
          const i = w.combo ? -1 : norm(w.t).indexOf(qn);
          const label = i >= 0 ? `${esc(w.t.slice(0, i))}<mark>${esc(w.t.slice(i, i + q.length))}</mark>${esc(w.t.slice(i + q.length))}` : esc(w.t);
          return `<li><a class="ps__kw" role="option" href="${w.u || searchUrl(w.t)}"><svg class="icon" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="10.5" cy="10.5" r="7" stroke="currentColor" stroke-width="1.5"/><path d="M15.6 15.6 20.5 20.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg><span>${label}${w.m ? ' <small>marque</small>' : ''}</span></a></li>`;
        });
        list.insertAdjacentHTML('afterbegin', items.join(''));
        $$('[role="option"]', panel).forEach((o, k) => { o.id = `ps-opt-${k + 1}`; });
        if ($('.ps__cols', panel) && !$('.ps__all', panel)) panel.insertAdjacentHTML('beforeend', `<a class="ps__all" role="option" href="${searchUrl(q)}">Voir tous les résultats pour « ${esc(q)} »</a>`);
      }
      // Produits de la marque tapée en premier
      const brand = brandIn(q);
      const plist = $('#ps-lbl-prod', panel)?.nextElementSibling;
      if (brand && plist) {
        const bn = norm(brand.t);
        [...plist.children].sort((a, b) => (norm($('.ps__meta strong', b)?.textContent || '') === bn) - (norm($('.ps__meta strong', a)?.textContent || '') === bn)).forEach((li) => plist.append(li));
        $$('[role="option"]', panel).forEach((o, k) => { o.id = `ps-opt-${k + 1}`; });
      }
      active = -1; open();
    };
    const load = async (q) => {
      if (cache.has(q)) { render(cache.get(q), q); return; }
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      panel.classList.add('is-loading');
      const params = new URLSearchParams({ q, section_id: 'predictive-search' });
      params.set('resources[type]', 'query,collection,product');
      params.set('resources[limit]', '6');
      params.set('resources[limit_scope]', 'each');
      params.set('resources[options][unavailable_products]', 'last');
      params.set('resources[options][fields]', 'title,product_type,vendor,variants.sku,variants.title,tag');
      try {
        const res = await fetch(`${psForm.dataset.psUrl}?${params}`, { signal: ctrl.signal });
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const html = doc.querySelector('[data-ps-results]')?.innerHTML || '';
        cache.set(q, html);
        if (input.value.trim() === q) render(html, q);
      } catch (e) {
        if (e.name !== 'AbortError') close();
      } finally { panel.classList.remove('is-loading'); }
    };
    input.addEventListener('input', () => {
      const q = input.value.trim();
      syncClear();
      clearTimeout(timer);
      if (q.length < 2) { const was = !panel.hidden; close(); lastQ = ''; startDesktop(was); return; }
      if (q === lastQ) return;
      lastQ = q;
      timer = setTimeout(() => load(q), 160);
    });
    input.addEventListener('focus', () => { enterSearch(); if (input.value.trim().length >= 2 && panel.innerHTML) open(); else startDesktop(); });
    input.addEventListener('click', startDesktop);
    if (clearBtn) clearBtn.addEventListener('click', () => {
      const was = !panel.hidden;
      input.value = ''; lastQ = ''; syncClear();
      if (isMobile()) { close(); input.focus(); return; }
      // Ordinateur : on remet l'écran de départ sans le fermer, donc sans rejouer l'animation
      input.focus(); panel.classList.remove('is-start'); startDesktop(was);
    });
    if (backBtn) backBtn.addEventListener('click', exitSearch);
    syncClear();
    input.addEventListener('keydown', (e) => {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { e.preventDefault(); if (searching()) exitSearch(); else close(); }
      else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); options()[active].click(); }
    });
    document.addEventListener('click', (e) => { if (!searching() && !psForm.contains(e.target)) close(); });
    // Un clic dans le panneau (sélection de texte, zone vide) retire le focus du champ : on ne ferme pas pour autant
    let dansPanneau = false;
    panel.addEventListener('pointerdown', () => { dansPanneau = true; });
    document.addEventListener('pointerup', () => { setTimeout(() => { dansPanneau = false; }, 0); });
    panel.addEventListener('click', (e) => { if (e.target.closest('.ps-x')) { e.preventDefault(); if (searching()) exitSearch(); else close(); input.blur(); } });
    psForm.addEventListener('focusout', (e) => { if (!psForm.contains(e.relatedTarget)) setTimeout(() => { if (!dansPanneau && !searching() && !psForm.contains(document.activeElement)) close(); }, 0); });
    window.addEventListener('resize', () => { if (!panel.hidden) place(); });
    window.addEventListener('scroll', () => { if (!panel.hidden) place(); }, { passive: true });
  }

  /* ---------- Menu mobile plein écran ---------- */
  const drawer = $('[data-drawer]');
  const openers = $$('[data-drawer-open]');
  let opener = openers[0];
  if (drawer && opener) {
    const closer = $('[data-drawer-close]', drawer);
    // Deux niveaux : la liste des familles, puis une famille. Retour à la liste à chaque fermeture.
    const body = $('[data-drawer-body]', drawer);
    const panels = $$('[data-dpanel]', drawer);
    const showPanel = (id, focusEl, retour = false) => {
      panels.forEach((pn) => { pn.hidden = pn.dataset.dpanel !== id; pn.classList.toggle('is-retour', retour); });
      if (body) body.scrollTop = 0;
      if (focusEl) focusEl.focus();
    };
    let lastOpener = null;
    $$('[data-dpanel-open]', drawer).forEach((b) => b.addEventListener('click', () => {
      lastOpener = b;
      const target = b.dataset.dpanelOpen;
      showPanel(target, $(`[data-dpanel="${target}"] [data-dpanel-back]`, drawer));
    }));
    $$('[data-dpanel-back]', drawer).forEach((b) => b.addEventListener('click', () => showPanel('racine', lastOpener, true)));
    // Ouverture et fermeture animées : la feuille glisse, le fond s'assombrit (voir .drawer.is-open dans base.css).
    let closeTimer;
    const close = (restore = true) => {
      drawer.classList.remove('is-open');
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => { drawer.hidden = true; showPanel('racine'); }, reduced.matches ? 0 : 320);
      opener.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('is-locked');
      if (restore) opener.focus();
    };
    openers.forEach((o) => o.addEventListener('click', () => {
      opener = o;
      clearTimeout(closeTimer);
      drawer.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.add('is-open')));
      opener.setAttribute('aria-expanded', 'true');
      document.body.classList.add('is-locked');
      closer.focus();
    }));
    closer.addEventListener('click', () => close());
    drawer.addEventListener('click', (e) => { if (e.target === drawer) close(); });
    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      const f = $$('a[href], button, summary', drawer).filter((el) => el.offsetParent !== null);
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    window.matchMedia('(min-width: 1024px)').addEventListener('change', (e) => { if (e.matches && !drawer.hidden) close(false); });
  }

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = megaBtns.find((b) => b.getAttribute('aria-expanded') === 'true');
    if (open) { setMega(open, false); open.focus(); }
  });

  /* ---------- Rails horizontaux ---------- */
  /* ---------- Défilement natif sans fin ----------
     La liste est triplée (copie avant, originaux, copie après) et on reste dans les originaux :
     quand le défilement s'arrête trop loin, on saute d'une copie entière, contenu identique,
     donc invisible. La vraie fin n'est jamais atteinte. actif() dit si le mode natif est en service. */
  const sansFin = (cadre, liste, actif = () => true) => {
    const originaux = [...liste.children];
    const n = originaux.length;
    if (n < 2) return () => false;
    const copie = () => originaux.map((el) => {
      const c = el.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.querySelectorAll('[id]').forEach((x) => x.removeAttribute('id'));
      c.querySelectorAll('a, button, input, select, textarea').forEach((x) => x.setAttribute('tabindex', '-1'));
      // Les copies affichent tout de suite les images (déjà en cache) : pas de case vide qui « se recharge » après un saut
      c.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      return c;
    });
    liste.prepend(...copie());
    liste.append(...copie());
    let t; let cible = null;
    const lot = () => n * (originaux[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(liste).columnGap) || 0));
    // Saut invisible d'une copie entière : sans fondu, et l'état « à moitié sorti » des cartes est recalculé
    // immédiatement, sinon les cartes nouvellement visibles s'effacent puis réapparaissent (effet de rechargement).
    const sauter = (d) => {
      cadre.classList.add('is-jumping');
      cadre.scrollTo({ left: cadre.scrollLeft + d, behavior: 'instant' });
      const f = cadre.getBoundingClientRect();
      [...liste.children].forEach((c) => {
        const r = c.getBoundingClientRect();
        const vu = Math.max(0, Math.min(r.right, f.right) - Math.max(r.left, f.left));
        c.classList.toggle('is-out', r.width ? vu / r.width < 0.5 : false);
      });
      requestAnimationFrame(() => requestAnimationFrame(() => cadre.classList.remove('is-jumping')));
    };
    const recycler = () => {
      const L = lot();
      if (!actif() || !L || cadre.scrollWidth <= cadre.clientWidth + 8) return false;
      const d = cadre.scrollLeft < L * 0.5 ? L : cadre.scrollLeft > L * 1.5 ? -L : 0;
      if (!d) return false;
      sauter(d);
      return true;
    };
    // Une rafale de clics annule chaque animation en cours (scrollend tombe entre deux clics) :
    // on ne lâche la cible qu'une fois atteinte, ou dès que l'utilisateur fait défiler lui-même.
    const fin = () => { if (cible !== null && Math.abs(cadre.scrollLeft - cible) > 2) return; cible = null; recycler(); };
    ['wheel', 'touchstart', 'pointerdown'].forEach((e) => cadre.addEventListener(e, () => { cible = null; }, { passive: true }));
    if ('onscrollend' in window) cadre.addEventListener('scrollend', fin);
    else cadre.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(fin, 250); }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(() => recycler()).observe(cadre);
    recycler();
    /* Flèches et auto-défilement : on part de la position visée (pas de la position en cours d'animation),
       chaque clic compte même en rafale ; si la cible sort de la copie du milieu, on saute d'une copie avant. */
    return (dir, w, doux = true) => {
      const L = lot();
      let x = (cible ?? cadre.scrollLeft) + dir * w;
      const d = !L ? 0 : x < L * 0.5 ? L : x > L * 1.5 ? -L : 0;
      if (d) { x += d; sauter(d); }
      cible = x;
      // Cartes qui vont sortir : le fondu démarre dès le clic, en même temps que le défilement (pas coupées net au bord)
      const f = cadre.getBoundingClientRect();
      [...liste.children].forEach((c) => {
        const r = c.getBoundingClientRect();
        const g = r.left - f.left + cadre.scrollLeft;
        const vu = Math.max(0, Math.min(g + r.width, x + cadre.clientWidth) - Math.max(g, x));
        if (r.width && vu / r.width < 0.5) c.classList.add('is-out');
      });
      cadre.scrollTo({ left: x, behavior: doux ? 'smooth' : 'auto' });
    };
  };

  $$('[data-rail-section]').forEach((sec) => {
    const rails = $$('[data-rail]', sec);
    const prev = $('[data-rail-prev]', sec);
    const next = $('[data-rail-next]', sec);
    if (!rails.length || !prev || !next) return;
    const rail = () => rails.find((r) => r.offsetParent !== null) || rails[0];
    const step = () => { const r = rail(); const c = r.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(r).columnGap || 0) : r.clientWidth * 0.9; };
    const update = () => {
      const r = rail();
      prev.disabled = next.disabled = r.scrollWidth <= r.clientWidth + 8;
    };
    const defilements = new Map();
    const go = (dir) => { const r = rail(); defilements.get(r)(dir, step(), !reduced.matches); };
    prev.addEventListener('click', () => { go(-1); relancer(); });
    next.addEventListener('click', () => { go(1); relancer(); });
    rails.forEach((r) => { r.addEventListener('scroll', update, { passive: true }); defilements.set(r, sansFin(r, r)); });
    window.addEventListener('resize', update);
    update();

    /* Défilement automatique : une carte toutes les N secondes, sans fin.
       Pause au survol, au focus clavier, au toucher et hors écran ; désactivé si mouvement réduit. */
    const delai = +sec.dataset.railAuto * 1000;
    let timer = null;
    const arrets = new Set(['hors-ecran']);
    function tick() {
      const r = rail();
      go(1);
    }
    function lancer() { clearInterval(timer); if (delai && !reduced.matches && !arrets.size) timer = setInterval(tick, delai); }
    function relancer() { lancer(); }
    function arreter(raison) { arrets.add(raison); clearInterval(timer); }
    function reprendre(raison) { arrets.delete(raison); lancer(); }
    if (!delai) return;
    sec.addEventListener('mouseenter', () => arreter('survol'));
    sec.addEventListener('mouseleave', () => reprendre('survol'));
    sec.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) arreter('focus'); });
    sec.addEventListener('focusout', () => reprendre('focus'));
    // Au doigt : le décompte s'arrête, puis repart de zéro (délai complet) une fois le défilement terminé.
    rails.forEach((r) => {
      r.addEventListener('touchstart', () => { arreter('toucher'); clearTimeout(r._t); }, { passive: true });
      const relacher = () => { clearTimeout(r._t); r._t = setTimeout(() => reprendre('toucher'), 300); };
      r.addEventListener('touchend', relacher, { passive: true });
      if ('onscrollend' in window) r.addEventListener('scrollend', () => { if (arrets.has('toucher')) relacher(); });
    });
    new IntersectionObserver(([e]) => (e.isIntersecting ? reprendre('hors-ecran') : arreter('hors-ecran')), { threshold: 0.3 }).observe(sec);
  });

  /* ---------- Pages marques : vignettes des tuiles par type ----------
     Tuiles rendues par le serveur ; on y ajoute la photo d'un produit de chaque type (données ?view=types). */
  $$('[data-types]').forEach(async (nav) => {
    const base = nav.dataset.types;
    try {
      const lire = (n) => fetch(`${base}?view=types&page=${n}`, { credentials: 'same-origin' }).then((r) => r.json());
      const p1 = await lire(1);
      const autres = await Promise.all(Array.from({ length: Math.max(0, p1.pages - 1) }, (_, k) => lire(k + 2)));
      const img = new Map();
      [p1, ...autres].flatMap((d) => d.p).forEach((p) => { if (p.t && p.i && !img.has(p.t)) img.set(p.t, p.i); });
      $$('a[data-type]', nav).forEach((a) => {
        const src = img.get(a.dataset.type);
        const box = $('.subcats__img', a);
        if (src && box && !box.firstChild) box.innerHTML = `<img src="${src.replace(/"/g, '&quot;')}" alt="" width="320" height="320" loading="lazy">`;
      });
    } catch (_) { /* tuiles sans vignette */ }
  });

  /* ---------- Pages de contenu : tuiles des types de produits d'une marque (même source que sa page collection) ----------
     Types d'au moins 2 produits, les plus fournis d'abord, accessoires en dernier ; lien vers la collection filtrée par type. */
  $$('[data-types-tuiles]').forEach(async (ul) => {
    const base = ul.dataset.typesTuiles;
    try {
      const lire = (n) => fetch(`${base}?view=types&page=${n}`, { credentials: 'same-origin' }).then((r) => r.json());
      const p1 = await lire(1);
      const autres = await Promise.all(Array.from({ length: Math.max(0, p1.pages - 1) }, (_, k) => lire(k + 2)));
      const types = new Map();
      [p1, ...autres].flatMap((d) => d.p).forEach((p) => {
        if (!p.t) return;
        const t = types.get(p.t) || { n: 0, i: '' };
        t.n += 1; if (!t.i && p.i) t.i = p.i;
        types.set(p.t, t);
      });
      const esc = (v) => String(v).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      const acc = (t) => t.toLowerCase().startsWith('accessoire');
      ul.innerHTML = [...types].filter(([, v]) => v.n > 1)
        .sort((a, b) => (acc(a[0]) - acc(b[0])) || (b[1].n - a[1].n))
        .map(([t, v]) => `<li><a href="${base}?filter.p.product_type=${encodeURIComponent(t)}"><span class="cat-tiles__img cat-tiles__img--photo">${v.i ? `<img src="${esc(v.i)}" alt="" width="320" height="320" loading="lazy">` : ''}</span><span class="cat-tiles__name">${esc(t)}</span><small>${v.n} produits</small></a></li>`)
        .join('');
    } catch (_) { ul.innerHTML = `<li><a href="${base}"><span class="cat-tiles__name">Voir toute la gamme</span></a></li>`; }
  });

  /* ---------- Typographie française : espace insécable avant ? ! : ; et à l'intérieur des guillemets ----------
     Les textes saisis dans Shopify utilisent souvent une espace normale : « ? » pouvait alors partir seul à la ligne. */
  const insecables = (racine) => {
    const w = document.createTreeWalker(racine, NodeFilter.SHOW_TEXT, { acceptNode: (n) => (n.parentElement && n.parentElement.closest('script, style, textarea, input, code') ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT) });
    for (let n = w.nextNode(); n; n = w.nextNode()) {
      const t = n.nodeValue.replace(/[ \t]+([?!:;»])/g, '\u00a0$1').replace(/«[ \t]+/g, '«\u00a0');
      if (t !== n.nodeValue) n.nodeValue = t;
    }
  };
  insecables(document.body);

  /* ---------- Textes longs : sommaire construit à partir des H2, rubrique en cours surlignée ---------- */
  $$('[data-longread]').forEach((bloc) => {
    const titres = $$('.longread__body h2', bloc).filter((h) => h.textContent.trim());
    // L'encart « Besoin d'un conseil ? » est toujours présent ; le sommaire seulement s'il y a au moins 2 rubriques
    $('.longread__aside', bloc).hidden = false;
    bloc.classList.add('has-toc');
    const ol = $('.longread__toc ol', bloc);
    if (titres.length < 2) { $('.longread__toc', bloc).hidden = true; return; }
    titres.forEach((h, k) => {
      if (!h.id) h.id = `rubrique-${k + 1}`;
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${h.id}`;
      a.textContent = h.textContent.trim();
      li.append(a);
      ol.append(li);
    });
    const liens = $$('a', ol);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entrees) => entrees.forEach((e) => {
        if (!e.isIntersecting) return;
        liens.forEach((l) => l.classList.toggle('is-on', l.getAttribute('href') === `#${e.target.id}`));
      }), { rootMargin: '-20% 0px -70% 0px' });
      titres.forEach((h) => io.observe(h));
    }
  });

  /* ---------- Textes d'introduction repliés à 3 lignes (pages marques) ---------- */
  $$('[data-fold]').forEach((bloc) => {
    const btn = bloc.nextElementSibling;
    if (!btn || !btn.matches('[data-fold-toggle]')) return;
    // Replié dès le rendu serveur (pas de texte qui s'ouvre puis se referme) ; on déplie seulement si le texte est court
    if (bloc.scrollHeight <= bloc.clientHeight + 4) { bloc.classList.remove('is-folded'); btn.hidden = true; return; }
    // Ouverture et fermeture animées (hauteur), sans saut
    btn.addEventListener('click', () => {
      const ouvrir = bloc.classList.contains('is-folded');
      const h0 = bloc.offsetHeight;
      bloc.classList.toggle('is-folded', false);
      const hOuvert = bloc.scrollHeight;
      bloc.classList.add('is-folded');
      const hFerme = bloc.offsetHeight;
      bloc.classList.remove('is-folded');
      const h1 = ouvrir ? hOuvert : hFerme;
      btn.setAttribute('aria-expanded', String(ouvrir));
      btn.textContent = ouvrir ? 'Réduire' : 'Lire la suite';
      if (reduced.matches) { bloc.classList.toggle('is-folded', !ouvrir); return; }
      bloc.style.overflow = 'hidden';
      bloc.style.height = `${h0}px`;
      bloc.getBoundingClientRect();
      bloc.style.transition = 'height .4s cubic-bezier(.2,.7,.2,1)';
      bloc.style.height = `${h1}px`;
      const fin = (e) => {
        if (e && e.propertyName !== 'height') return;
        bloc.removeEventListener('transitionend', fin);
        bloc.style.transition = bloc.style.height = bloc.style.overflow = '';
        bloc.classList.toggle('is-folded', !ouvrir);
      };
      bloc.addEventListener('transitionend', fin);
    });
  });

  /* ---------- Listes de filtres longues : fondu en bas tant qu'il reste des valeurs ---------- */
  $$('.filter__list').forEach((l) => {
    const maj = () => l.classList.toggle('has-more', l.scrollHeight - l.clientHeight - l.scrollTop > 4);
    l.addEventListener('scroll', maj, { passive: true });
    maj();
  });

  /* ---------- Pagination : « … » → champ « aller à la page » ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-page-jump]');
    if (!b) return;
    const max = parseInt(b.dataset.pages, 10) || 1;
    const champ = document.createElement('input');
    champ.type = 'number'; champ.min = '1'; champ.max = String(max); champ.inputMode = 'numeric';
    champ.className = 'pagination__champ'; champ.placeholder = `1–${max}`;
    champ.setAttribute('aria-label', `Numéro de page, de 1 à ${max}`);
    b.replaceWith(champ);
    champ.focus();
    const aller = () => {
      const n = Math.min(max, Math.max(1, parseInt(champ.value, 10) || 0));
      if (!champ.value) { champ.replaceWith(b); return; }
      const u = new URL(window.location.href);
      u.searchParams.set('page', String(n));
      window.location.href = u.toString();
    };
    champ.addEventListener('keydown', (ev) => { if (ev.key === 'Enter') { ev.preventDefault(); aller(); } else if (ev.key === 'Escape') champ.replaceWith(b); });
    champ.addEventListener('blur', () => { if (champ.value) aller(); else champ.replaceWith(b); });
  });

  /* ---------- Bandes défilantes (onglets du blog, tuiles de catégories) : flèches quand la ligne dépasse ---------- */
  $$('[data-tabs-scroll]').forEach((nav) => {
    const ul = $('ul', nav);
    const prev = $('[data-tabs-prev]', nav);
    const next = $('[data-tabs-next]', nav);
    const debuts = () => [...ul.children].map((li) => li.offsetLeft - ul.firstElementChild.offsetLeft);
    const maj = () => {
      const deborde = ul.scrollWidth > ul.clientWidth + 2;
      nav.classList.toggle('has-arrows', deborde);
      prev.hidden = next.hidden = !deborde;
      const p = typeof cible === 'number' ? cible : ul.scrollLeft;
      prev.disabled = p < 4;
      next.disabled = p + ul.clientWidth >= ul.scrollWidth - 4;
      nav.classList.toggle('fade-left', deborde && !prev.disabled);
      nav.classList.toggle('fade-right', deborde && !next.disabled);
    };
    // Défilement animé jusqu'au début d'un onglet (jamais de mot coupé à gauche)
    // Bandes de tuiles avec fondu au bord : la tuile visée commence juste après le fondu (44 px), pas dessous
    const subcats = nav.classList.contains('subcats');
    // Miniatures de la fiche et rails produits : une vignette par clic.
    // Tuiles de catégories : une page par clic (retour de Luc du 28/10/2026 : une tuile par clic n'avançait presque pas) ;
    // la première tuile coupée à droite devient la première visible, calée juste après le fondu du bord (44 px sur ordinateur).
    const tuiles = nav.classList.contains('pdp__thumbnav') || nav.classList.contains('rail-nav');
    const decal = subcats ? (window.matchMedia('(max-width: 899px)').matches ? 0 : 44) : 0;
    // Clics en rafale : on part de la position visée (pas de la position en cours d'animation) ; l'aimantation
    // est suspendue pendant le défilement par flèche, sinon elle ramène la bande en arrière sur téléphone.
    let cible = null;
    const pos = () => (cible ?? ul.scrollLeft);
    const aller = (x) => {
      cible = Math.max(0, Math.min(x > 0 ? x - decal : 0, ul.scrollWidth - ul.clientWidth));
      ul.style.scrollSnapType = 'none';
      ul.scrollTo({ left: cible, behavior: reduced.matches ? 'auto' : 'smooth' });
      maj();
    };
    const fin = () => { if (cible !== null && Math.abs(ul.scrollLeft - cible) > 2) return; cible = null; ul.style.scrollSnapType = ''; };
    if ('onscrollend' in window) ul.addEventListener('scrollend', fin);
    else ul.addEventListener('scroll', () => { clearTimeout(ul._t); ul._t = setTimeout(fin, 200); }, { passive: true });
    ['touchstart', 'wheel', 'pointerdown'].forEach((ev) => ul.addEventListener(ev, () => { cible = null; ul.style.scrollSnapType = ''; }, { passive: true }));
    const largeurs = () => [...ul.children].map((li) => li.offsetWidth);
    next.addEventListener('click', () => {
      const p = pos();
      if (subcats) {
        const d = debuts();
        const l = largeurs();
        const vue = p + ul.clientWidth - decal;
        const i = d.findIndex((x, k) => x + l[k] > vue + 2 && x - decal > p + 4);
        aller(i > -1 ? d[i] : ul.scrollWidth);
        return;
      }
      const bord = p + ul.clientWidth * 0.7;
      const apres = debuts().filter((x) => x - decal > p + 4);
      aller(tuiles ? (apres[0] ?? ul.scrollWidth) : (apres.filter((x) => x <= bord).pop() ?? apres[0] ?? ul.scrollWidth));
    });
    prev.addEventListener('click', () => {
      const p = pos();
      if (subcats) {
        const d = debuts();
        const l = largeurs();
        // La tuile coupée (ou cachée) juste à gauche devient la dernière entièrement visible
        const avant = d.map((x, i) => i).filter((i) => d[i] - decal < p - 4);
        const j = avant.pop();
        const fin = j !== undefined ? d[j] + l[j] : p;
        const k = d.findIndex((x) => x - decal >= fin - ul.clientWidth + decal - 2);
        const cibleX = k > -1 ? d[k] : 0;
        aller(cibleX - decal < p - 4 ? cibleX : (d.filter((x) => x - decal < p - 4).pop() ?? 0));
        return;
      }
      const bord = p - ul.clientWidth * 0.7;
      const avant = debuts().filter((x) => x - decal < p - 4);
      aller(tuiles ? (avant.pop() ?? 0) : (avant.find((x) => x >= bord) ?? avant.pop() ?? 0));
    });
    ul.addEventListener('scroll', maj, { passive: true });
    window.addEventListener('resize', maj);
    maj();
    // Les largeurs changent quand la police Barlow est chargée
    if (document.fonts) document.fonts.ready.then(maj);
    // L'onglet actif est ramené dans la zone visible au chargement
    const actif = $('[aria-current="page"]', ul);
    if (actif && nav.classList.contains('has-arrows')) { ul.style.scrollBehavior = 'auto'; ul.scrollLeft = actif.offsetLeft - ul.offsetLeft - 16; ul.style.scrollBehavior = ''; maj(); }
  });

  /* ---------- Défilement des marques : pause ---------- */
  $$('[data-marquee-toggle]').forEach((btn) => {
    const marquee = btn.closest('section').querySelector('[data-marquee]');
    btn.addEventListener('click', () => {
      const paused = marquee.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', String(paused));
      btn.setAttribute('aria-label', paused ? 'Reprendre le défilement des marques' : 'Mettre en pause le défilement des marques');
      $('[data-icon-pause]', btn).hidden = paused;
      $('[data-icon-play]', btn).hidden = !paused;
    });
  });

  /* ---------- Apparitions au défilement ---------- */
  if (document.documentElement.classList.contains('js-reveal')) {
    const items = $$('.reveal');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      else io.observe(el);
    });
    reduced.addEventListener('change', (e) => { if (e.matches) items.forEach((el) => el.classList.add('is-in')); });
    window.addEventListener('pageshow', (e) => { if (e.persisted) items.forEach((el) => el.classList.add('is-in')); });
  }

  /* ---------- Panier (AJAX Shopify) ---------- */
  const setCartCount = (n) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = !n; });
  };
  // Pastille du panier bougée dès le clic ; la réponse de Shopify donne ensuite le total réel
  const bougerCompte = (delta) => {
    const actuel = parseInt($('[data-cart-count]')?.textContent, 10) || 0;
    setCartCount(Math.max(0, actuel + delta));
  };
  // Écritures panier une par une : deux requêtes simultanées peuvent s'écraser côté Shopify (article supprimé qui revient).
  let filePanier = Promise.resolve();
  const enFile = (fn) => { const p = filePanier.then(fn, fn); filePanier = p.catch(() => {}); return p; };
  window.mpEnFile = enFile;
  const addToCart = async (id, quantity, btn, title) => {
    btn?.setAttribute('aria-busy', 'true');
    bougerCompte(Number(quantity) || 1);
    // Notification tout de suite (remplacée par le message d'erreur en cas d'échec).
    // Le panneau panier ne s'ouvre pas tout seul : le client l'ouvre en cliquant sur « Panier » (choix de Luc, 29/10/2026).
    notify(title || 'Produit', '/cart', 'Voir le panier', { titre: 'Ajouté au panier' });
    try {
      const res = await enFile(() => fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] }),
      }));
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Ajout impossible');
      if (btn) { btn.classList.add('is-done'); setTimeout(() => btn.classList.remove('is-done'), 1600); }
    } catch (err) {
      notify(err.message, '/cart', 'Voir le panier', { erreur: true });
    } finally {
      btn?.removeAttribute('aria-busy');
    }
    // Resynchronisation dans tous les cas : sur stock insuffisant, Shopify répond 422 mais ajoute quand même la quantité disponible
    try {
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      setCartCount(cart.item_count);
      syncCartes(cart);
    } catch (err) { /* l'affichage se recalera au prochain chargement */ }
  };
  window.mpAddToCart = addToCart;

  /* ---------- Panneau panier à droite (section panier-tiroir) ----------
     S'ouvre après un ajout au panier et au clic sur l'icône panier (sauf sur la page panier).
     Quantités et accessoires se modifient dans le panneau, qui se recharge depuis le serveur. */
  const tiroir = $('[data-tiroir]');
  if (tiroir && !location.pathname.startsWith('/cart')) {
    const contenu = $('[data-tiroir-contenu]', tiroir);
    let retourFocus = null;
    // encoreValable : le contenu reçu n'est posé que si aucun clic n'a eu lieu pendant le rechargement,
    // sinon il effacerait des suppressions faites entre-temps (l'envoi suivant rechargera).
    const charger = async (encoreValable = () => true) => {
      // Adresse complète de la page (garde preview_theme_id en aperçu), plus le paramètre sections
      const u = new URL(location.href);
      u.hash = '';
      u.searchParams.set('sections', 'panier-tiroir');
      // Sans en-tête Accept JSON : sur une fiche, Shopify renverrait le produit au lieu des sections
      const r = await fetch(u);
      const data = await r.json();
      if (!data['panier-tiroir']) throw new Error('Panneau panier indisponible');
      if (!encoreValable()) return;
      contenu.innerHTML = data['panier-tiroir'];
      clesServeur = null;
      contenu.classList.remove('is-vide');
    };
    const fermer = () => {
      tiroir.classList.remove('is-ouvert');
      document.body.classList.remove('is-locked');
      setTimeout(() => { tiroir.hidden = true; }, reduced.matches ? 0 : 300);
      retourFocus?.focus?.();
    };
    const ouvrir = async () => {
      retourFocus = document.activeElement;
      try { await charger(); } catch (_) { location.href = '/cart'; return; }
      tiroir.hidden = false;
      document.body.classList.add('is-locked');
      requestAnimationFrame(() => requestAnimationFrame(() => tiroir.classList.add('is-ouvert')));
      contenu.focus({ preventScroll: true });
    };
    const rafraichir = async (cart) => {
      if (cart && typeof cart.item_count === 'number') setCartCount(cart.item_count);
      else window.mpSyncCart?.();
      if (cart) syncCartes(cart);
      const s = seq;
      await charger(() => s === seq);
    };
    window.mpTiroir = { ouvrir, fermer };
    // Quantités : affichage immédiat (chiffre, prix de la ligne, total, compteur), envoi 350 ms après le dernier clic,
    // puis rechargement du panneau depuis le serveur seulement si aucun autre clic n'a eu lieu entre-temps.
    const TAUX = 1.2;
    let attente = null;
    let seq = 0;
    // Clés des lignes présentes chez Shopify après le dernier envoi (null : le panneau affiché reflète le serveur)
    let clesServeur = null;
    const totaux = () => {
      let ttc = 0;
      let nb = 0;
      $$('[data-tligne]', contenu).forEach((l) => { const q = Number(l.dataset.qte); ttc += q * Number(l.dataset.uniteTtc); nb += q; });
      const ht = Math.round(ttc / TAUX);
      const tht = $('[data-tiroir-total-ht]', contenu);
      const tttc = $('[data-tiroir-total-ttc]', contenu);
      if (tht) tht.textContent = euro(ht, 'HT');
      if (tttc) tttc.textContent = euro(ttc, 'TTC');
      setCartCount(nb);
    };
    const envoyerQuantites = () => {
      clearTimeout(attente);
      const mon = ++seq;
      attente = setTimeout(async () => {
        try {
          // Corps calculé au moment de l'envoi (dans la file), par clé de ligne (une suppression décale les positions).
          // Une ligne déjà supprimée côté Shopify n'est plus envoyée : sa clé inconnue ferait rejeter tout l'envoi (422)
          // et les autres suppressions seraient perdues.
          const { res, cart } = await enFile(async () => {
            const updates = Object.fromEntries($$('[data-tligne]', contenu)
              .filter((l) => Number(l.dataset.qte) > 0 || !clesServeur || clesServeur.has(l.dataset.tligne))
              .map((l) => [l.dataset.tligne, Number(l.dataset.qte)]));
            const r = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
            const c = await r.json();
            if (r.ok) clesServeur = new Set((c.items || []).map((i) => i.key));
            return { res: r, cart: c };
          });
          if (!res.ok) throw new Error(cart.description || cart.message || 'Quantité indisponible');
          if (mon !== seq) return;
          setCartCount(cart.item_count);
          syncCartes(cart);
          await charger(() => mon === seq);
        } catch (err) {
          notify(err.message, '/cart', 'Voir le panier', { erreur: true, titre: 'Panier non modifié' });
          if (mon === seq) { await charger(() => mon === seq).catch(() => {}); window.mpSyncCart?.(); }
        }
      }, 350);
    };
    tiroir.addEventListener('click', async (e) => {
      if (e.target.closest('[data-tiroir-fermer]')) { fermer(); return; }
      const pas = e.target.closest('[data-tiroir-pas]');
      if (pas) {
        const l = pas.closest('[data-tligne]');
        const q = Math.max(0, Number(l.dataset.qte) + Number(pas.dataset.tiroirPas));
        l.dataset.qte = q;
        $('[data-tligne-n]', l).textContent = q;
        $('[data-tiroir-pas="-1"]', l).classList.toggle('is-trash', q <= 1);
        // Ligne retirée : elle disparaît tout de suite (gardée masquée pour l'envoi de la quantité 0)
        l.hidden = q === 0;
        const vide = !$$('[data-tligne]', contenu).some((x) => !x.hidden);
        contenu.classList.toggle('is-vide', vide);
        const ttc = q * Number(l.dataset.uniteTtc);
        $('[data-tligne-ht]', l).textContent = euro(Math.round(ttc / TAUX), 'HT');
        $('[data-tligne-ttc]', l).textContent = euro(ttc, 'TTC');
        totaux();
        envoyerQuantites();
        return;
      }
      const a = e.target.closest('[data-tiroir-ajout]');
      if (!a) return;
      const carte = a.closest('.tacc');
      carte?.classList.add('is-envoi');
      try {
        const res = await enFile(() => fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(a.dataset.tiroirAjout), quantity: 1 }] }) }));
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Ajout impossible');
        const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        await rafraichir(cart);
      } catch (err) {
        notify(err.message, '/cart', 'Voir le panier', { erreur: true, titre: 'Panier non modifié' });
        carte?.classList.remove('is-envoi');
      }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !tiroir.hidden) fermer(); });
    // Icône panier de l'en-tête et lien « Voir le panier » de la notification : ouvrent le panneau au lieu de changer de page
    document.addEventListener('click', (e) => {
      const lien = e.target.closest('a[href="/cart"]');
      if (!lien || !lien.closest('header, .hdr, [data-header], .toast') || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      ouvrir();
    });
  }

  /* ---------- Cartes produit et fiche : quantité au panier (− n +) ----------
     Affichage immédiat (optimiste) : chaque clic met à jour tout de suite toutes les zones du même produit ;
     l'envoi part 350 ms après le dernier clic, et la réponse du serveur n'écrase l'affichage que si
     aucun autre clic n'a eu lieu entre-temps (pas de 3 → 4 → 3 → 4). */
  const TRASH = '<svg class="icon icon--trash" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5.5 7h13l-.81 10.97c-.13 1.77-.95 2.53-2.72 2.53H9.03c-1.77 0-2.59-.76-2.72-2.53L5.5 7Z"/><path d="M3.5 7h17M9 7V5.05c0-.91.39-1.3 1.3-1.3h3.4c.91 0 1.3.39 1.3 1.3V7M10 11v5.5M14 11v5.5"/></svg>';
  const voulu = new Map();
  const enCours = new Map();
  const afficher = (id, n) => {
    $$(`[data-buy="${id}"]`).forEach((box) => {
      $$('[data-add-cart], [data-buy-hide]', box).forEach((el) => { el.hidden = n > 0; });
      $$('[data-step], [data-buy-show]', box).forEach((el) => { el.hidden = n === 0; });
      const nEl = $('[data-step-n]', box);
      if (nEl) nEl.textContent = n;
      // À 1 exemplaire, le − devient une corbeille : le clic retire l'article du panier
      $$('[data-step-moins]', box).forEach((m) => {
        const corbeille = n <= 1;
        if (m.classList.contains('is-trash') === corbeille && m.dataset.label) return;
        m.dataset.label ||= m.getAttribute('aria-label');
        m.classList.toggle('is-trash', corbeille);
        m.innerHTML = corbeille ? TRASH : '−';
        m.setAttribute('aria-label', corbeille ? m.dataset.label.replace(/^Retirer un /, 'Supprimer ') : m.dataset.label);
      });
    });
  };
  function syncCartes(cart) {
    const q = new Map();
    (cart.items || []).forEach((it) => q.set(String(it.variant_id), (q.get(String(it.variant_id)) || 0) + it.quantity));
    const ids = new Set($$('[data-buy]').map((b) => b.dataset.buy));
    ids.forEach((id) => { if (!enCours.has(id)) afficher(id, q.get(id) || 0); });
  }
  window.mpAfficherQte = afficher;
  window.mpSyncCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then(syncCartes).catch(() => {});
  if ($('[data-buy]')) window.mpSyncCart();
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-step-plus], [data-step-moins]');
    if (!b) return;
    const box = b.closest('[data-buy]');
    const id = box.dataset.buy;
    const base = voulu.has(id) ? voulu.get(id) : (parseInt($('[data-step-n]', box).textContent, 10) || 0);
    const n = Math.max(0, base + (b.matches('[data-step-plus]') ? 1 : -1));
    voulu.set(id, n);
    bougerCompte(n - base);
    afficher(id, n);
    const etat = enCours.get(id) || { seq: 0 };
    etat.seq += 1;
    const seq = etat.seq;
    clearTimeout(etat.t);
    enCours.set(id, etat);
    etat.t = setTimeout(async () => {
      try {
        const res = await enFile(() => fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id, quantity: n }) }));
        const cart = await res.json();
        if (!res.ok) throw new Error(cart.description || cart.message || 'Quantité indisponible');
        setCartCount(cart.item_count);
        if (etat.seq === seq) {
          enCours.delete(id);
          voulu.delete(id);
          const reel = (cart.items || []).filter((it) => String(it.variant_id) === id).reduce((a, it) => a + it.quantity, 0);
          afficher(id, reel);
        }
      } catch (err) {
        if (etat.seq === seq) { enCours.delete(id); voulu.delete(id); window.mpSyncCart(); }
        notify(err.message, '/cart', 'Voir le panier', { erreur: true, titre: 'Quantité non modifiée' });
      }
    }, 350);
  });
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-add-cart]');
    if (!btn) return;
    e.preventDefault();
    // Carte produit : le sélecteur apparaît tout de suite à 1, la réponse du serveur confirme ensuite
    if (btn.closest('[data-buy]') && window.mpAfficherQte) window.mpAfficherQte(btn.dataset.addCart, 1);
    addToCart(btn.dataset.addCart, 1, btn, btn.dataset.title);
  });

  /* ---------- Devis (localStorage, format compatible avec l'ancien thème : otec_devis) ---------- */
  const KEY = 'otec_devis';
  const Quote = {
    read() {
      try { const s = JSON.parse(localStorage.getItem(KEY)); return s && Array.isArray(s.items) ? s : { items: [] }; }
      catch (_) { return { items: [] }; }
    },
    write(s) {
      try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (_) { /* stockage indisponible */ }
      document.dispatchEvent(new CustomEvent('otec:devis:updated', { detail: s }));
    },
    add(item) {
      const s = this.read();
      const found = s.items.find((i) => String(i.variantId) === String(item.variantId));
      if (found) found.quantity = (parseInt(found.quantity, 10) || 1) + (item.quantity || 1);
      else s.items.push({ quantity: 1, ...item });
      this.write(s);
    },
    set(variantId, q) {
      const s = this.read();
      s.items = s.items.map((i) => (String(i.variantId) === String(variantId) ? { ...i, quantity: q } : i)).filter((i) => i.quantity > 0);
      this.write(s);
    },
    clear() { this.write({ items: [] }); },
    count() { return this.read().items.reduce((n, i) => n + (parseInt(i.quantity, 10) || 0), 0); },
  };
  window.mpQuote = Quote;
  const setQuoteCount = () => {
    const n = Quote.count();
    $$('[data-quote-count]').forEach((el) => { el.textContent = n; el.hidden = !n; });
  };
  document.addEventListener('otec:devis:updated', setQuoteCount);
  window.addEventListener('storage', (e) => { if (e.key === KEY) setQuoteCount(); });
  setQuoteCount();
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-add-quote]');
    if (!btn) return;
    e.preventDefault();
    const d = btn.dataset;
    const qtyInput = d.qtyInput ? document.getElementById(d.qtyInput) : null;
    Quote.add({
      variantId: d.variant, title: d.title, url: d.url, image: d.image, vendor: d.vendor, sku: d.sku,
      priceTtcCents: parseInt(d.price, 10) || 0, quantity: parseInt(qtyInput?.value, 10) || 1,
      surDevis: d.surDevis === '1',
    });
    notify(d.title, d.quoteUrl || '/pages/demande-devis', 'Voir le devis', { titre: 'Ajouté au devis' });
    btn.classList.add('is-done');
    setTimeout(() => btn.classList.remove('is-done'), 1600);
  });


  /* ---------- Affichage des prix HT ou TTC (mémorisé) ---------- */
  const setTax = (mode) => {
    document.body.classList.toggle('show-ttc', mode === 'ttc');
    $$('[data-tax]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.tax === mode)));
    try { localStorage.setItem('mp_tax', mode); } catch (_) { /* stockage indisponible */ }
  };
  let taxMode = 'ht';
  try { taxMode = localStorage.getItem('mp_tax') || 'ht'; } catch (_) { /* défaut HT */ }
  setTax(taxMode);
  // Les prix s'effacent, la bascule se fait pendant qu'ils sont invisibles, puis ils reviennent.
  let taxTimer;
  $$('[data-tax]').forEach((b) => b.addEventListener('click', () => {
    const mode = b.dataset.tax;
    if (document.body.classList.contains('show-ttc') === (mode === 'ttc')) return;
    $$('[data-tax]').forEach((x) => x.setAttribute('aria-pressed', String(x.dataset.tax === mode)));
    if (reduced.matches) { setTax(mode); return; }
    clearTimeout(taxTimer);
    document.documentElement.classList.add('is-taxing');
    taxTimer = setTimeout(() => {
      setTax(mode);
      requestAnimationFrame(() => requestAnimationFrame(() => document.documentElement.classList.remove('is-taxing')));
    }, 140);
  }));

  /* ---------- Cartes au bord du cadre : effacées en fondu (PC, voir base.css) ----------
     Entrée : la carte apparaît quand la moitié est visible. Sortie : le fondu démarre dès qu'elle commence
     à sortir (moins de 85 % visible), pour être terminé avant que le bord ne la coupe. */
  const marquerSorties = (cadre) => {
    if (!('IntersectionObserver' in window)) return;
    const avant = new WeakMap();
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      const r = e.intersectionRatio;
      const sort = r < (avant.get(e.target) ?? 1);
      avant.set(e.target, r);
      e.target.classList.toggle('is-out', sort ? r < 0.85 : r < 0.5);
    }), { root: cadre, threshold: [0, 0.5, 0.85, 1] });
    const suivre = () => [...(cadre.querySelector('.loop__track') || cadre).children].forEach((c) => io.observe(c));
    suivre();
  };
  $$('.rail').forEach(marquerSorties);

  /* ---------- Carrousels infinis ---------- */
  // Défilement natif partout (base.css), sans fin grâce à sansFin : les flèches, l'auto-défilement
  // et la souris font défiler le conteneur, on peut enchaîner les clics sans attendre la fin de l'animation.
  const loopTel = window.matchMedia('(max-width: 999px)');
  $$('[data-loop]').forEach((loop) => {
    const track = loop.querySelector('.loop__track');
    if (!track || track.children.length < 2) return;
    const aller = sansFin(loop, track);
    marquerSorties(loop);
    const instant = reduced.matches;
    let timer; let paused = false;
    const width = () => track.firstElementChild.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
    const defile = (dir) => aller(dir, width(), !instant);
    const next = () => defile(1);
    const prev = () => defile(-1);
    const play = () => { clearInterval(timer); if (!instant && loop.dataset.loop !== 'manual') timer = setInterval(() => { if (!paused && !document.hidden) next(); }, 4500); };
    ['mouseenter', 'focusin'].forEach((e) => loop.addEventListener(e, () => { paused = true; }));
    ['mouseleave', 'focusout'].forEach((e) => loop.addEventListener(e, () => { paused = false; }));
    // Téléphone : le doigt prend la main ; quand le défilement s'arrête, le décompte repart de zéro (délai complet)
    let reprise; let doigt = false;
    const relacher = () => { clearTimeout(reprise); reprise = setTimeout(() => { doigt = false; paused = false; play(); }, 300); };
    loop.addEventListener('touchstart', () => { doigt = true; paused = true; clearInterval(timer); clearTimeout(reprise); }, { passive: true });
    loop.addEventListener('touchend', relacher, { passive: true });
    if ('onscrollend' in window) loop.addEventListener('scrollend', () => { if (doigt) relacher(); });
    // PC : glisser à la souris
    let x0 = null;
    loop.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse' || loopTel.matches) return; x0 = e.clientX; paused = true; });
    loop.addEventListener('pointerup', (e) => { if (x0 === null) return; const dx = e.clientX - x0; if (dx < -40) next(); else if (dx > 40) prev(); x0 = null; paused = false; play(); });
    const sec = loop.closest('section');
    sec?.querySelector('[data-loop-prev]')?.addEventListener('click', () => { prev(); play(); });
    sec?.querySelector('[data-loop-next]')?.addEventListener('click', () => { next(); play(); });
    play();
  });

  /* ---------- Onglets de sélection produits ---------- */
  $$('[data-tabset]').forEach((set) => {
    const tabs = $$('[role="tab"]', set);
    const panels = $$('[role="tabpanel"]', set);
    tabs.forEach((t) => t.addEventListener('click', () => {
      tabs.forEach((x) => x.setAttribute('aria-selected', String(x === t)));
      panels.forEach((p) => { p.hidden = p.id !== t.getAttribute('aria-controls'); });
    }));
  });

  // Bandeau marque : rotation des cartes. Arrêt tant qu'il est survolé, focalisé ou hors de l'écran.
  $$('[data-band]').forEach((band) => {
    const slides = $$('.band__in', band);
    const dots = $$('[data-band-dot]', band);
    const fonds = $$('.band__bg', band);
    const delay = parseFloat(getComputedStyle(band).getPropertyValue('--band-delay')) * 1000 || 7000;
    const calme = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const arrets = new Set(['hors-ecran']);
    let cur = 0, timer = null, reste = delay, debut = 0;
    band.classList.add('is-paused');
    const show = (i) => {
      [slides[cur], dots[cur], fonds[cur]].forEach((el) => el && el.classList.remove('is-on'));
      slides[cur].setAttribute('aria-hidden', 'true'); slides[cur].inert = true; dots[cur].removeAttribute('aria-current');
      cur = i;
      [slides[cur], dots[cur], fonds[cur]].forEach((el) => el && el.classList.add('is-on'));
      slides[cur].removeAttribute('aria-hidden'); slides[cur].inert = false; dots[cur].setAttribute('aria-current', 'true');
      reste = delay;
    };
    const lancer = () => {
      clearTimeout(timer);
      if (calme || arrets.size) return;
      debut = Date.now();
      timer = setTimeout(() => { show((cur + 1) % slides.length); lancer(); }, reste);
    };
    const arreter = (raison) => {
      if (!arrets.size) { clearTimeout(timer); reste = Math.max(0, reste - (Date.now() - debut)); }
      arrets.add(raison); band.classList.add('is-paused');
    };
    const reprendre = (raison) => {
      arrets.delete(raison);
      if (!arrets.size) { band.classList.remove('is-paused'); lancer(); }
    };
    // Un clic sur une barre relance tout de suite le décompte, même si la souris est sur le bandeau
    dots.forEach((d) => d.addEventListener('click', () => {
      if (+d.dataset.bandDot !== cur) show(+d.dataset.bandDot);
      arrets.delete('survol'); arrets.delete('focus');
      if (!arrets.size) { band.classList.remove('is-paused'); lancer(); }
    }));
    band.addEventListener('mouseenter', () => arreter('survol'));
    band.addEventListener('mouseleave', () => reprendre('survol'));
    // Pause au focus seulement pour la navigation clavier
    band.addEventListener('focusin', (e) => { if (e.target.matches(':focus-visible')) arreter('focus'); });
    band.addEventListener('focusout', (e) => { if (!band.contains(e.relatedTarget)) reprendre('focus'); });
    new IntersectionObserver(([e]) => (e.isIntersecting ? reprendre : arreter)('hors-ecran'), { threshold: .4 }).observe(band);
  });

  /* ---------- Formulaires (contact, SAV, devis) : bouton grisé tant qu'il manque une information ;
     un clic sur le bouton grisé signale chaque champ manquant en rouge, avec un message sous le bouton. ---------- */
  $$('#form-contact, #form-sav, #form-devis').forEach((form) => {
    const btn = form.querySelector('button[type="submit"]');
    if (!btn) return;
    form.noValidate = true;
    const alerte = document.createElement('p');
    alerte.className = 'form-alerte';
    alerte.setAttribute('role', 'alert');
    alerte.hidden = true;
    btn.after(alerte);
    const champs = () => [...form.elements].filter((el) => el.willValidate && !el.closest('[hidden]'));
    const conteneur = (el) => el.closest('.field, fieldset, .quote__consent') || el.parentElement;
    const message = (el) => {
      if (el.type === 'checkbox') return 'Cochez cette case pour envoyer votre demande.';
      if (el.type === 'radio') return 'Choisissez une réponse.';
      if (el.validity.valueMissing) return 'Ce champ est obligatoire.';
      if (el.type === 'email' && el.validity.typeMismatch) return 'Adresse e-mail incomplète (exemple : nom@entreprise.fr).';
      if (el.validity.patternMismatch) return 'Format non valide.';
      return el.validationMessage;
    };
    const marquer = (c, el, msg) => {
      c.classList.toggle('is-erreur', !!msg);
      let m = c.querySelector(':scope > .form-erreur');
      if (msg) {
        if (!m) { m = document.createElement('small'); m.className = 'form-erreur'; c.append(m); }
        m.textContent = msg;
      } else m?.remove();
      c.querySelectorAll('input, textarea, select').forEach((x) => { if (msg && x === el) x.setAttribute('aria-invalid', 'true'); else x.removeAttribute('aria-invalid'); });
    };
    const verifier = () => {
      const groupes = new Map();
      champs().forEach((el) => { const c = conteneur(el); if (!groupes.has(c)) groupes.set(c, []); groupes.get(c).push(el); });
      let premier = null;
      let n = 0;
      groupes.forEach((els, c) => {
        const faux = els.find((el) => !el.validity.valid);
        marquer(c, faux, faux ? message(faux) : '');
        if (faux) { n += 1; premier = premier || faux; }
      });
      alerte.hidden = !n;
      alerte.textContent = n === 1 ? 'Il reste 1 information à compléter, signalée en rouge.' : `Il reste ${n} informations à compléter, signalées en rouge.`;
      return premier;
    };
    let tente = false;
    const etat = () => {
      const ok = form.checkValidity();
      btn.classList.toggle('is-incomplet', !ok);
      if (tente) verifier();
    };
    form.addEventListener('input', etat);
    form.addEventListener('change', etat);
    // Champs rendus obligatoires par un choix (ex. téléphone pour « Être rappelé ») : recalcul après les autres scripts
    form.addEventListener('change', () => setTimeout(etat, 0));
    form.addEventListener('submit', (e) => {
      if (form.checkValidity()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      tente = true;
      const premier = verifier();
      if (premier) {
        conteneur(premier).scrollIntoView({ block: 'center', behavior: reduced.matches ? 'auto' : 'smooth' });
        premier.focus({ preventScroll: true });
      }
    }, true);
    etat();
  });

  window.mpReady = true;
})();
